import React, {useState} from "react";
import {View, TouchableOpacity} from "react-native";
import PtText from "../../core/pt-text/pt-text";
import PtOrderStatusIndicator from "./../pt-order-status-indicator/pt-order-status-indicator";
import {getTranslation} from "../../../helpers/getTranslation";
import PtProductPriceDetails from "./../pt-product-price-details/pt-product-price-details";
import PtIcon from "../../core/pt-icon/pt-icon";
import PtOrderItemDetails from "./../pt-order-item-details/pt-order-item-details";
import PtOrderHistoryBomItem from "./../pt-order-history-bom-item/pt-order-history-bom-item";
import {PtOrderHistoryProductProps} from './pt-order-history-product-props';
import {styles} from './pt-order-history-product-styles';

export default function PtOrderHistoryProduct(props: PtOrderHistoryProductProps) {

  /** labels */
  const materialNumberLabel = props.materialNumberLabel || getTranslation('order.history.product.material.number.label') || 'Mat. Number';
  const quantityLabel = props.quantityLabel || getTranslation('order.history.product.quantity.label') || 'Quantity';
  const distributionCenterLabel = props.distributionCenterLabel || getTranslation('order.history.product.distribution.center.label') || 'Distribution center';
  const componentsLabel = props.componentsLabel || getTranslation('order.history.product.components.label') || 'Components';

  /** data */
  const order = props.order;
  const productData = props.productData ? props.productData : null;

  /** settings */
  const [displayComponents, setDisplayComponents] = useState(false);

  /** combos helpers */
  const bomProductInfo = () => {
    return productData.product?.bomTypeData?.code ?? ''
  };
  const showComponents = () => {
    return ['BUNDLE','JITKIT'].includes(bomProductInfo())
  };
  const isBundle = () => {
    return bomProductInfo() === 'BUNDLE'
  };

  const toggleComponents = () => {
    setDisplayComponents(!displayComponents)
  };

  /** renders */
  const renderMaterialNumber = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtText style={[styles.sectionLabelText]}>
            {materialNumberLabel}
          </PtText>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText style={[styles.sectionValueText]}>
            {productData?.product?.code ? productData.product.code : productData?.product?.sku}
          </PtText>
          <PtText style={[styles.sectionValueText]}>
            {productData?.product?.name}
          </PtText>
        </View>
      </View>
    )
  }

  const renderProductQuantity = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtText style={[styles.sectionLabelText]}>
            {quantityLabel}
          </PtText>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText style={[styles.sectionValueText]}>
            {productData?.quantity}
          </PtText>
        </View>
      </View>
    )
  }

  const renderPrices = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtProductPriceDetails
            productData={productData}
            useModal={true}
          />
        </View>
        <View style={[styles.sectionValue]}>
          <PtText style={[styles.sectionValueText, styles.bold]}>
            {productData?.totalPrice?.formattedValue}
          </PtText>
          <PtText style={[styles.sectionValueText]}>
            {productData?.itemPrice?.formattedValue ? `${productData.itemPrice.formattedValue}/each` : ''}
          </PtText>
        </View>
      </View>
    )
  }

  const renderDistributionCenter = () => {
    return (
      <View style={[styles.sectionContainer]}>
        <View style={[styles.sectionLabel]}>
          <PtText style={[styles.sectionLabelText]}>
            {distributionCenterLabel}
          </PtText>
        </View>
        <View style={[styles.sectionValue]}>
          <PtText styles={[styles.sectionValueText]}>
            {productData?.distributionCenter}
          </PtText>
        </View>
      </View>
    )
  }

  return (
    <View style={[styles.productDataContainer]}>
      <View style={[styles.lineItemHeader]}>
        <View style={[styles.lineItemNumber]}>
          <PtText style={[styles.lineItemNumberText]}>No {productData?.entryNumber}</PtText>
        </View>
        <View style={[styles.lineItemStatus]}>
          {!isBundle() ?
            <PtOrderStatusIndicator statusCode={productData.statusCode} />
            : null
          }
        </View>
      </View>

      {renderMaterialNumber()}
      {renderProductQuantity()}

      {!showComponents() ?
        renderPrices()
        : null
      }

      {renderDistributionCenter()}

      {showComponents() ?
        <View style={[styles.componentsContainer]}>
          <View style={[styles.componentsContainerHeader]}>
            <TouchableOpacity onPress={() => toggleComponents()}>
              <PtText style={[styles.componentsContainerHeaderText]}>
                <PtIcon iconName={displayComponents ? 'up' : 'down'} style={[styles.componentsContainerHeaderText]}/>
                {componentsLabel}
              </PtText>
            </TouchableOpacity>
          </View>
          {displayComponents ?
            <View style={[styles.componentsFlyout]}>
              {productData.boschSalesBOMItems?.map((bomItem:any, idx:number) => (
                <View key={`bom-item-${idx}`}>
                  <PtOrderHistoryBomItem itemData={bomItem} order={order} orderItem={productData}/>
                </View>
              ))}
            </View>
            : null
          }
        </View>
        :
        <View style={[styles.sectionContainer]}>
          <View style={[styles.sectionRow]}>
            <PtOrderItemDetails order={order} orderItem={productData}/>
          </View>
        </View>
      }
    </View>
  )
}